import { Box, CardMedia, Container, Grid, Typography } from '@mui/material'
import React from 'react'
import Accordions from './Accordions'
import vid from "./../assets/daP.mp4"

function ServisCard({ img, title, desc, img2, title2, desc2 }) {
    return (
        <>
            <Container>
                <Grid container sx={{ alignItems: 'center', mt: 2 }} spacing={{ md: 2, xs: 0 }} >
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }} >
                            <Typography
                                variant="h4"
                                component="h3"
                                sx={{
                                    mb: "10px",
                                    fontWeight: "bold",
                                    color: "#76232d"
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                color={"GrayText"}
                                sx={{
                                    maxWidth: { md: "100%", xs: "100%" },
                                    fontSize: 16,
                                    lineHeight: 1.2,
                                    p: 4,
                                    // height: '250px'
                                }}
                                className="cardTestim"
                            >{desc}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', }} >
                            <Box className="header" sx={{ mt: { md: 7, xs: 1 } }} >
                                <Box className='' sx={{ display: 'flex', mt: { md: '15px', xs: 1 }, justifyContent: 'center' }} >
                                    <video autoPlay={true} muted src={vid} loop width={'90%'} style={{ borderBottomLeftRadius: '80px', borderBottomRightRadius: '80px' }} >
                                        Your browser does not support the video tag.
                                    </video>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
            <Container>
                <Grid container sx={{ alignItems: 'center', mt: 2 }} spacing={2} >
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', }} >
                            <Typography
                                variant="h4"
                                component="h3"
                                sx={{
                                    mb: "10px",
                                    fontWeight: "bold",
                                    color: "#76232d",
                                    mt: { md: 1, xs: 1 }
                                }}
                            >
                                {title2}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                color={"GrayText"}
                                sx={{
                                    maxWidth: { md: "100%", xs: "100%" },
                                    fontSize: 16,
                                    lineHeight: 1.2,
                                    p: 4,
                                    // height: '250px'
                                }}
                                className="cardTestim"
                            >{desc2}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', }} >
                            <CardMedia
                                sx={{ borderRadius: "30px" }}
                                component="img"
                                alt="green iguana"
                                image={img2}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
            {/* <Container
                sx={{
                    // mt: "-70px",
                    // mb: 5,
                }}
            >
                <Box display={"flex"} flexDirection={{ md: "row", xs: "column" }} gap={4} sx={{ margenTop: { md: 0, xs: "50px" } }} alignItems={"center"} justifyContent={"center"} >
                    <Accordions />
                    <CardMedia
                        sx={{ width: { md: "40%", xs: "100%" }, borderRadius: "30px" }}
                        component="img"
                        alt="green iguana"
                        image={img}
                    />
                </Box>
            </Container> */}
        </>
    )
}

export default ServisCard